// import React from "react";
// import { useNavigate } from "react-router-dom";
// import india from '../images/india.png';
// import international from '../images/international.png';

// const Isame2025 = () => {
//   const navigate = useNavigate();

//   const countries = [
//     { name: "India", year: 1956, code: "in" },
//     { name: "Afghanistan", year: 2018, code: "af" },
//     { name: "Bahrain", year: 1978, code: "bh" },
//     { name: "Bangladesh", year: 1958, code: "bd" },
//     { name: "Bhutan", year: 2010, code: "bt" },
//     { name: "Iraq", year: 2006, code: "iq" },
//     { name: "Jordan", year: 1953, code: "jo" },
//     { name: "Lebanon", year: 1952, code: "lb" },
//     { name: "Maldives", year: 2006, code: "mv" },
//     { name: "Nepal", year: 1971, code: "np" },
//     { name: "Pakistan", year: 1956, code: "pk" },
//     { name: "Palestine", year: 2009, code: "ps" },
//     { name: "Srilanka", year: 1958, code: "lk" },
//     { name: "UAE", year: 2015, code: "ae" }
//   ];

//   return (
//     <div style={{ padding: 20, fontFamily: "Arial, sans-serif" }}>



//     </div>
//   );
// };

// export default Isame2025;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { translateText } from "../Navbar/Navbar";
import forumPdf from "./Images/Glimpses of Forum.pdf";
import { FaDownload, FaLink, FaGoogleDrive } from "react-icons/fa";
import axios from "axios";
const APII = "https://lcoiapi.emedha.in/appi";

const Isame2025 = ({ selectedLang }) => {
    const navigate = useNavigate();

    //   const [translated, setTranslated] = useState({
    //     Gallery: "",
    //     BacktoDirectory: "",
    //     Glimpses: "",
    //   });
    const [translated, setTranslated] = useState({
        Gallery: "",
        BacktoDirectory: "",
        ISAMEAreaMeetingTitle: "",
        ISAMEAreaMeetingPara1: "",
        ISAMEAreaMeetingPara2: "",
        ISAMEAreaMeetingPara3: "",
        ISAMEAreaMeetingPara: "",
        MissionPara: "",
        LCIFTitle: "",
        LCIFPara: "",
        SeminarsTitle: "",
        InaugurationTitle: "",
        InaugurationPara: "",
        EntertainmentTitle: "",
        EntertainmentPara: "",
        WeServeTitle: "",
        WeServePara: "",
        BanquetTitle: "",
        businessPara: "",
        BazaarTitle: "",
        bazaarPara: "",
        GofInaugrationPara: "",
        GofInaugration: "",

    });


    const [imagesData, setImagesData] = useState([]);

    const fetchImages = async () => {
        try {
            const res = await axios.get(`${APII}/images`);
            setImagesData(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const getImagesByTitle = (title) => {
        return imagesData.filter(img => img.title === title);
    };


    const downloadPDF = () => {
        const link = document.createElement("a");
        link.href = forumPdf;
        link.download = "Glimpses of Forum.pdf";
        link.click();
    };


    const openDriveLink = () => {
        window.open(
            "https://drive.google.com/drive/folders/1oWkyIizOvdOGONWE3EAOCpz_aEh5J1yd",
            "_blank"
        );
    };


    useEffect(() => {
        async function translateAll() {
            const englishTexts = {
                Gallery: "Gallery",
                BacktoDirectory: "Back to Directory",

                // Sections
                ISAMEAreaMeetingTitle: "ISAME Area Leadership Meeting",
                // ISAMEAreaMeetingPara:
                //     `In this meeting International Board Approved Third Vice President Candidate C Robert Rettby from Switzerland was considered as an ISAME supported candidate. \n Hyderabad 2024 forum report was presented by Forum Chairman R Sunil kumar and Board Liaison Baburao G. The new ISAME forum agreement were also reviewed and recommended for the consultative assembly to be approved.`,
                ISAMEAreaMeetingPara: [
                    "In this meeting International Board Approved Third Vice President Candidate C Robert Rettby from Switzerland was considered as an ISAME supported candidate.",
                    "Hyderabad 2024 forum report was presented by Forum Chairman R Sunil kumar and Board Liaison Baburao G. The new ISAME forum agreement were also reviewed and recommended for the consultative assembly to be approved."
                ],
                MissionTitle: "MISSION 1.5",
                MissionPara: [
                    "This was attended by Mission 1.5 Chairperson PIP Frank Moore, Executive officers, CA Leaders, Area leaders and Vice Area Leaders.",
                    "The performance were reported and reviewed by each one and further strategies to achieve the goal for June 2026 was discussed."
                ],
                LCIFTitle: "LCIF Area Leadership Meeting",
                LCIFPara: [
                    "LCIF Trustees, LCIF CA Leaders, LCIF Area Leaders and LCIF MD Coordinators attended this meeting.",
                    "The performance of ISAME Area was found to be exceptional during this year and the meeting ended with confidence of raising 100% cash goals."
                ],
                SeminarsTitle: `The activities of the ISAME Forum on 16TH December shifted to Mahatma
Mandir, Gandhinagar, one of the largest convention centers in Gujarat.
This was a dream project of the then Chief Minister Shri. Narendrabhai
Modi.`,

                InaugurationTitle: "GLIMPSES OF ISAME FORUM OPENING",
                InaugurationPara: [
                    //"The forum was inaugurated by the Honorable Chief Minister of Gujarat State, Shri Bhupendrabhai Patel and addressed the august delegates.",
                    "ISAME FORUM 2025 WELCOMES DELEGATES FROM 24 COUNTRIES",
                    "CELEBRATING OPENING OF FORUM WITH GUJARATI GARBA (TRADITIONAL DANCE FORM)"
                ],
                EntertainmentTitle: "GLIMPSES OF REGISTRATION",
                EntertainmentPara:
                    //"Forum witnessed amazing entertainment events – Kathak Rockers (Kumar Sharma), Neha Dhupia, Cine Star, Havas Guruhi from Tashkent, Uzbekistan, Rodney & Band. Delegates enjoyed to their tunes of music and melody.",
                    "FORUM REGISTRATION – SEPARATE KIOSK FOR EACH MULTIPLE DISTRICT & COUNTRIES",
                WeServeTitle: "GLIMPSES OF SERVICE EXPO",
                WeServePara:
                    //  "An Initiative of Lions of India and News18 Channel to appreciate the Grassroot Innovations across Global South and awarded 10 recipients from across India.",
                    "GLIMPSES OF SERVICE EXPO SERVICE EXPO- An exhibit area for service projects from across multiples, Lions Club of Karnavati permanent projects and TB Booth were center of attraction with their service",
                BanquetTitle: "GLIMPSES OF LIONS BUSINESS NETWORK",
                businessPara: "Members of Lions Business Network (Ahmedabad Pioneer and Transformer Chapter) showcasing their products and services. Received interesting response from delegates for business opportunity.",
                BazaarTitle: "GLIMPSES OF LIONS BAZAAR",
                bazaarPara: "GLIMPSES OF LIONS BAZAAR LIONS Bazaar representing business of Lion members.",

                lionsBussExhibit: "Lions Business Exhibit involved corporate to represent services and products to the delegates.",


                LeoForum: "GLIMPSES OF LEO FORUM 2025",
                LeoForumPara: "LEO FORUM 2025 held at ISAME FORUM. A total of 70 leos from ISAME participated. Conducted their business sessions and had exceptional participation.",

                GofSeminar: "GLIMPSES OF SEMINARS",

                GofSeminar: "A total of 40 seminars in 5 tracks and 8 rooms, delegates had whole lot of learning, knowledge and interaction with faculties.",

                GofkeyNoteSpek: "GLIMPSES OF KEYNOTE SPEAKERS",

                GofInaugration: "GLIMPSES OF ISAME FORUM INAUGURATION",
                GofInaugrationPara: "The forum was inaugurated by the Honorable Chief Minister of Gujarat State, Shri. Bhupendrabhai Patel and addressed the august delegates.",

                HonoringARM: "Honoring of Smt. Asha Rohit Mehta",
                HonoringARMPara: "Smt. Asha Rohit Mehta was honored by the International President A P Singh for her commitment and dedication towards Lions Association and gratitude for her support",
                Glimpesofenter: "GLIMPSES OF ENTERTAINMENT",
                GlimpesofenterPara: "Forum witnessed amazing entertainment events – Kathak Rockers (Kumar Sharma), Neha Dhupia, Cine Star, Havas Guruhi from Tashkent, Uzbekistan, Rodney & Band. Delegates enjoyed to their tunes of music and melody",



                GlimpsTitle: "GLIMPSES OF WE SERVE INDIA",
                GlimpsTitlePara: "An Initiative of Lions of India and News18 Channel to appreciate the Grassroot Innovations across Global South and awarded 10 recipients from across India",


                GlimpsofPM: "GLIMPSES OF PRESIDENTIAL BANQUET",







            };

            let translatedObj = {};

            for (let key in englishTexts) {
                translatedObj[key] = await translateText(englishTexts[key], selectedLang);
            }

            setTranslated(translatedObj);
        }

        translateAll();
    }, [selectedLang]);

    const containerStyle = {
        padding: "2rem",
        fontFamily: "Arial",
        maxWidth: "1100px",
        margin: "0 auto",
    };

    const backButtonStyle = {
        marginBottom: "20px",
        padding: "8px 14px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
    };

    const titleStyle = {
        textAlign: "center",
        fontSize: "28px",
        fontWeight: "bold",
        marginBottom: "30px",
    };
    const driveBtn = {
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        padding: "8px 16px",
        background: "linear-gradient(45deg, #34a853, #0f9d58)",
        color: "#fff",
        borderRadius: "25px",
        border: "none",
        cursor: "pointer",
        marginLeft: "10px",
        fontSize: "14px",
        fontWeight: "bold",
    };
   
    const downloadBtn = {
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        padding: "8px 16px",
        background: "linear-gradient(45deg, #007bff, #00c6ff)",
        color: "#fff",
        borderRadius: "25px",
        border: "none",
        cursor: "pointer",
        marginBottom: "25px",
        fontSize: "14px",
        fontWeight: "bold",
    };

    const galleryGrid = {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
        gap: "20px",
        marginTop: "20px",
    };

    const imageStyle = {
        width: "100%",
        height: "200px",
        objectFit: "contain",
        borderRadius: "10px",
        transition: "transform 0.3s",
        cursor: "pointer",
    };
    const sectionStyle = {
        marginBottom: "40px",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    };

    const imageRow = {
        display: "flex",
        gap: "15px",
        marginTop: "15px",
        flexWrap: "wrap",
    };

    const imgStyle = {
        width: "300px",
        height: "200px",
        objectFit: "contain",
        borderRadius: "10px",
    };

    const handleNavigate = () => navigate("/leadersPage");




    return (
        <div style={containerStyle}>
            <h2 style={titleStyle}>{translated.Gallery}</h2>

           

            <div style={sectionStyle}>
                <h3>{translated.ISAMEAreaMeetingTitle}</h3>
                <p>{translated.ISAMEAreaMeetingPara[0]}</p>
                <p>{translated.ISAMEAreaMeetingPara[1]}</p>
                             <div style={imageRow}>
                    {getImagesByTitle("ISAME Area Leadership Meeting").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>


            <div style={sectionStyle}>
                <h3>{translated.MissionTitle}</h3>
                {/* <p>{translated.MissionPara}</p> */}

                <p>{translated.MissionPara[0]}</p>
                <p>{translated.MissionPara[1]}</p>

                <div style={imageRow}>
                    {getImagesByTitle("MISSION 1.5").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>


            <div style={sectionStyle}>
                <h3>{translated.LCIFTitle}</h3>
                {/* <p>{translated.LCIFPara}</p> */}
                <p>{translated.LCIFPara[0]}</p>
                <p>{translated.LCIFPara[1]}</p>
             
                <div style={imageRow}>
                    {getImagesByTitle("LCIF Area Leadership Meeting").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>


            <div style={sectionStyle}>
                <h3>{translated.SeminarsTitle}</h3>


            </div>
            <div style={sectionStyle}>
                <h3>ISAME COMMITTEES AND DONORS</h3>
             
                <div style={imageRow}>
                    {getImagesByTitle("ISAME COMMITTEES AND DONORS").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>


            <div style={sectionStyle}>
                <h3>{translated.InaugurationTitle}</h3>
                <p>{translated.InaugurationPara[0]}</p>
                <p>{translated.InaugurationPara[1]}</p>
               
                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF ISAME FORUM OPENING").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>

            </div>


            <div style={sectionStyle}>
                <h3>{translated.EntertainmentTitle}</h3>
                <p>{translated.EntertainmentPara}</p>

                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF REGISTRATION").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>


            <div style={sectionStyle}>
                <h3>{translated.WeServeTitle}</h3>
                <p>{translated.WeServePara}</p>

                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF SERVICE EXPO").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>

            </div>


            <div style={sectionStyle}>
                <h3>{translated.BanquetTitle}</h3>
                <p>{translated.businessPara}</p>

                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF LIONS BUSINESS NETWORK").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>
            <div style={sectionStyle}>
                <h3>{translated.BazaarTitle}</h3>
                <p>{translated.bazaarPara}</p>

                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF LIONS BAZAAR").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>


            <div style={sectionStyle}>
                <h3>{translated.lionsBussExhibit}</h3>
             
                <div style={imageRow}>
                    {getImagesByTitle("Lions Business Exhibit").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>
            <div style={sectionStyle}>
                <h3>{translated.LeoForum}</h3>
                <p>{translated.LeoForumPara}</p>

                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF LEO FORUM 2025").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  

            </div>
            <div style={sectionStyle}>
                <h3>{translated.GofSeminar}</h3>
             
                   <div style={imageRow}>
                    {getImagesByTitle("Seminars").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  
            </div>
            <div style={sectionStyle}>
                <h3>{translated.GofkeyNoteSpek}</h3>
     
                  <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF KEYNOTE SPEAKERS").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  
            </div>
            <div style={sectionStyle}>
                <h3>{translated.GofInaugration}</h3>
                <p>{translated.GofInaugrationPara}</p>

                 <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF ISAME FORUM INAUGURATION").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  
            </div>
            <div style={sectionStyle}>
                <h3>{translated.HonoringARM}</h3>
                <p>{translated.HonoringARMPara}</p>

                 <div style={imageRow}>
                    {getImagesByTitle("Honoring of Smt. Asha Rohit Mehta").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  
            </div>
            <div style={sectionStyle}>
                <h3>{translated.Glimpesofenter}</h3>
                <p>{translated.GlimpesofenterPara}</p>

                  <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF ENTERTAINMENT").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  
            </div>
            <div style={sectionStyle}>
                <h3>{translated.GlimpsTitle}</h3>
                <p>{translated.GlimpsTitlePara}</p>

                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF WE SERVE INDIA").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  
            </div>
            <div style={sectionStyle}>
                <h3>{translated.GlimpsofPM}</h3>



                <div style={imageRow}>
                    {getImagesByTitle("GLIMPSES OF PRESIDENTIAL BANQUET").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>  
            </div>
            {/* PDF Download Button */}
            <button style={downloadBtn} onClick={downloadPDF}>
                <FaLink />
                Glimpses of Forum
                <FaDownload />
            </button>

            {/* Google Drive Link Button */}
            <button style={driveBtn} onClick={openDriveLink}>
                <FaGoogleDrive />
                Google Drive Gallery
                <FaLink />
            </button>
            <div style={sectionStyle}>
                <h3>15-12-2025 -- Hotel Leela</h3>

                <div style={galleryGrid}>
                    {/* {galleryImages.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt="gallery"
                            style={imageStyle}
                            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                        />
                    ))} */}
                   
                    {getImagesByTitle("15-12-2025 -- Hotel Leela").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                  
                </div>
            </div>


            <div style={sectionStyle}>
                <h3>16-12-2025 </h3>

                <div style={galleryGrid}>
                    {/* {galleryImages2.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt="gallery"
                            style={imageStyle}
                            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                        />
                    ))} */}
                      {getImagesByTitle("16-12-2025").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>




            <div style={sectionStyle}>
                <h3>17-12-2025 </h3>

                <div style={galleryGrid}>
                    {/* {galleryImages3.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt="gallery"
                            style={imageStyle}
                            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                        />
                    ))} */}
                    {getImagesByTitle("17-12-2025").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>




            <div style={sectionStyle}>
                <h3>18-12-2025 </h3>

                <div style={galleryGrid}>
                    {/* {galleryImages4.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt="gallery"
                            style={imageStyle}
                            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                        />
                    ))} */}
                    {getImagesByTitle("18-12-2025").map((img, index) => (
                        <img
                            key={index}
                            src={img.image_url}
                            style={imgStyle}
                            alt="gallery"
                        />
                    ))}
                </div>
            </div>



        </div>
    );
};

export default Isame2025;